<script lang="ts">
	import { getHubStores } from '$lib/stores/hubStores';
	import { _ } from 'svelte-i18n';

	const { hub } = getHubStores();
</script>

{#if $hub?.settings.login_logo_url}
	<img class="logo" src={$hub?.settings.login_logo_url} alt={$_('hub.settings.design.hub.logo')} />
	<!-- login_logo is a deprecated field, though below is to support the case if hub logo is not updated after deprecation -->
{:else if $hub?.settings.login_logo?.url}
	<div class="oldLogo">
		<img src={$hub?.settings.login_logo?.url} alt={$_('hub.settings.design.hub.logo')} />
	</div>
{:else}
	<div class="logoPlaceholder" />
{/if}

<style>
	.logo,
	.logoPlaceholder,
	.oldLogo {
		block-size: auto;
		max-block-size: 90px;
		inline-size: auto;
		max-inline-size: 300px;
		margin-block-end: var(--gutterLarger);
	}

	.oldLogo {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
